import axios from "axios"
import { useAuth0 } from "@auth0/auth0-react"
import { useQuery } from "@tanstack/react-query"
import { usePermissionsList } from "./queries/usePermissions"

const useFetchTemplates = () => {
	const { getAccessTokenSilently, isAuthenticated } = useAuth0()
	const permissionsData = usePermissionsList()
	const canRead = permissionsData?.includes("read:templates") ?? false

	const query = useQuery({
		queryKey: ["templates"],
		queryFn: async () => {
			const token = await getAccessTokenSilently({
				authorizationParams: { audience: process.env.REACT_APP_API_IDENTIFIER }
			})
			const response = await axios.get(
				`${process.env.REACT_APP_BACKEND_URL}/api/template-schedules/all`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			return response.data.payload
		},
		enabled: isAuthenticated && canRead,
		staleTime: 1000 * 60 * 10,
		refetchOnMount: "always"
	})

	return {
		templatesData: query.data,
		templatesStatus: query.isLoading
			? "loading"
			: query.isError
				? "failed"
				: query.data
					? "succeeded"
					: "idle",
		templatesError: query.error?.message ?? null
	}
}

export default useFetchTemplates
